module.exports = __webpack_public_path__ + "img/a2_2_E.1667c30c.jpg";